module.exports = __webpack_public_path__ + "static/media/icn_pause.139e0ee1.svg";